{
    "nova": {
        "strong": [
            "Receive a vision of the past, present, or future",
            "Reveal someone’s hidden emotions, to themself or others.",
            "Use the Space Between to protect yourself or others",
            "Learn the secrets or purpose of something not understood",
            "Say “There is something here that we are missing.”"
        ],
        "lateral": [
            "Heal or soothe someone’s pain or duress, and give them a token.",
            "Ask “Why are you pursuing this goal?” and give them a token if they provide an answer."
        ],
        "vulnerable": [
            "Act on impulse, putting yourself in a dangerous situation",
            "Lose control of yourself or the Space Between and put someone you care about in danger",
            "React with scorn or doubt to something or someone you do not understand",
            "Assume good intentions from someone who means you harm",
            "Ask “How do I fall short of expectations right now?”"
        ]
    },
    "diplomat": {
        "strong": [
            "Reveal a contingency plan at a critical moment",
            "De-escalate conflict between parties with a common goal",
            "Enact a plan or order and follow it through"
        ],
        "lateral": [
            "Call in a favor from an ally, and give them a token",
            "Give someone a new responsibility, and give them a token",
            "Show someone you believe in them, and give them a token",
            "Ask “What would get you to side with me or my cause right now?” and give them a token if you act on their answer"
        ],
        "vulnerable": [
            "Act on impulse, putting yourself in a dangerous situation",
            "Get captured",
            "Discover a betrayal from a supposed ally",
            "Tell a hard truth in a way that hurts",
            "Ask “What have you been hiding from me?”"
        ]
    },
    "ace": {
        "strong": [
            "Get yourself or someone else out of harm’s way",
            "Make a daring maneuver to gain an advantageous position",
            "Maneuver an unfamiliar vehicle without trouble",
            "Take the lead in a moment of confusion or despair",
            "Ask “How are you vulnerable to me?”"
        ],
        "lateral": [
            "Ask the right person for help or guidance, and give them a token",
            "Ask “How could I best encourage you or give you hope right now?” and give them a token if you act on their answer"
        ],
        "vulnerable": [
            "Make a rash maneuver that puts you or others in danger",
            "Question someone’s authority in a time of confusion or despair",
            "Disregard the advice or concerns of those around you",
            "Say “We’ve got company.”",
            "Ask “What makes me vulnerable in this situation?”"
        ]
    },
    "space_between": {
        "moves": [
            "Invoke awe, and gain a token",
            "Reveal an old secret or new truth to someone, and give them a token",
            "Create an unexpected connection between people, and give them a token"
        ]
    },
    "mandate": {
        "moves": [
            "Foreshadow a larger threat, and gain a token",
            "Put someone in immediate danger, and give them a token",
            "Intercept information or supplies, and give a token to whom you’ve taken from"
        ]
    },
    "liberation": {
        "moves": [
            "Complicate someone’s vision of freedom, and gain a token",
            "Offer help and solidarity, with or without a cost. If they accept, give them a token",
            "Introduce dangerous plans and ask others to participate. if they do, give them a token",
            "Ask “What does a better world look like to you?” and give them a token if they answer"
        ]
    },
    "scum_and_villany": {
        "moves": [
            "Offer help or information at a cost. If they pay, give them a token",
            "Introduce or invite a betrayal, and gain a token",
            "Get someone involved in a dangerous scheme, and give them a token",
            "Complicate someone’s worldview, and gain a token"
        ]
    }
}